// Which deployment this bundle talks to. Matched on the HOSTNAME, never on the
// full href: `href.match('dev')` finds "dev" anywhere in the URL, so a prod page
// whose PATH happened to contain it — an application, entity or field named
// "dev-something" — silently pointed the API at dev, and the line below at
// Stripe's TEST key.
export const API_SERVER = window.location.host.match("127.0.0.1")?'http://127.0.0.1:8000/backend/api/':(window.location.hostname.startsWith('dev.')?'https://dev.migratis.ai/backend/api/':'https://migratis.ai/backend/api/');
export const STRIPE_API_KEY = window.location.hostname.startsWith('dev.')?"pk_test_51RqyyyPGwtp57pxfqRYymcjXFpsAVeOZRPUnouiJNbU8LpYVGFt2PpGMBsGEnJ42PpF8PZORFQEwrcNei546v0Po00OoqsiFAs":"pk_live_51M9oRxAXmadDuP9DSDzNetvVNXyzw4VEcbSZOvRC3LgXRfWZIATP8HvGSw5E8a0EPqSQTLJjPO3nqzFnoqjAusmH00XzZvbQgn";
export const ITEMS_PER_PAGE = 6;
export const COLOR_LINK = '#d9775798'
export const SUPPORT = true;
// A public contact form (`/contact`). Distinct from SUPPORT, which is the
// authenticated ticket queue: the shell offers whichever exists, and a
// deployment with neither must not be shown a link to either.
export const CONTACT = true;
export const SUBSCRIPTION = true;
// Free trial on new subscriptions. Keep in sync with backend SUBSCRIPTION_TRIAL.
export const TRIAL = false;
export const MIGRATIS = false;
export const GENERATOR = true;
// Credit balance / metered-billing widget (standalone `credits` module). Can be
// activated independently of the generator — e.g. shipped into base.
export const CREDITS = true;
// Road-following routes for `geo` fields in geo_mode='route' (`routing` module).
// The flag only says the UI *may* offer waypoint editing; whether it actually
// does is measured at runtime against GET /routing/availability, because a host
// can install the module and run no engine (SCOPE_road_routing.md@8914275 §10).
export const ROUTING = true;
// External data sources (`datasource` module). The flag only says the UI *may*
// offer a lookup button; whether one appears is decided per entity by the
// declarations the application actually carries — an application that declares
// no source shows exactly today's plain form
// (SCOPE_external_data_sources.md@d2de531 §10 item 1).
export const DATASOURCE = true;
